'use client';

import clsx from 'clsx';
import React from 'react';

import { useDataProvider } from '@/components/flow/components/DataProvider/useDataProvider';
import { useFlowContext } from '@/components/flow/hooks/useFlowContext';
import { DATA_KEYS } from '@/consts/dataKeys';

import { OtcCard } from './components/OtcCard';
import { useOtcCards } from '../../hooks/useOtcCards';
import { ExplanatoryText } from '../explanatoryText';
import { Subheader } from '../subheader';

export const OtcCards = ({
  checkboxSelector = false,
  fullWidth = false,
  type,
}: {
  checkboxSelector?: boolean;
  fullWidth?: boolean;
  type: 'recommended' | 'addons';
}) => {
  const { brand } = useFlowContext();
  const { cardsOfType } = useOtcCards();
  const { flags } = useDataProvider(DATA_KEYS.productSelection);

  const cards = cardsOfType(type);

  const isHorizontal =
    brand !== 'agency' && flags.isSkinnyTrial && cards.length === 1;

  if (!cards.length) {
    return null;
  }

  return (
    <div className="cur-flex cur-flex-col cur-gap-2">
      {type === 'recommended' && flags.yourRoutineEssentialsCopy && (
        <ExplanatoryText
          marginTopClass=""
          text={flags.yourRoutineEssentialsCopy}
        />
      )}
      {type === 'addons' && flags.addMoreToYourBoxCopy && (
        <Subheader text={flags.addMoreToYourBoxCopy} />
      )}
      <ul
        className={clsx(
          'cur-flex cur-flex-wrap cur-m-0 -cur-mr-4',
          isHorizontal && 'cur-flex-col',
        )}
      >
        {cards.map((card) => (
          <OtcCard
            key={card.id}
            card={card}
            checkboxSelector={checkboxSelector}
            fullWidth={fullWidth}
            isHorizontal={isHorizontal}
          />
        ))}
      </ul>
    </div>
  );
};
